'use strict';

wbApp.controller('FinanceSummaryCtrl', ['$scope', '$timeout', '$translate', 'invoiceSvc', 'semesterSvc', 'securitySvc',
function ($scope, $timeout, $translate, invoiceSvc, semesterSvc, securitySvc) {
    
    if (!securitySvc.isInRole('Dashboard.FinanceSummary')) {
        return;
    }

    var activeSemesterPromise = semesterSvc.getDefaultAsync();

    // Wait for active semester
    activeSemesterPromise.then(function (activeSemester) {
        if (activeSemester) {
            $scope.semesterID = activeSemester.id;
        } else {
            $scope.semesterID = null;
        }

        $scope.onSemesterChange($scope.semesterID);
    });

    $scope.chart = {
        type: 'ComboChart',
        data: [
            [$translate.instant('TXT_LBL_SEMESTER'), $translate.instant('TXT_LBL_COURSES'), $translate.instant('TXT_LBL_ACTIONS'), $translate.instant('TXT_VAL_ONEOFF'), $translate.instant('TXT_LBL_PAYMENTS')],
            ["",0,0,0,0]
        ],
        options: {
            displayExactValues: true,
            isStacked: true,
            chartArea: { width: '70%', height: '60%' },
            legend: { position: 'bottom' },
            seriesType: "bars",
            series: { 3: { type: "line" }}
        }
    };

    $scope.semesterData = {};

    function selectSemesterData(data, semesterID) {
        for (var i = 0; i < data.length; i++) {
            var d = data[i];
            if (d.semesterID == semesterID) {
                $scope.semesterData = d;
                break;
            }
        }
    }

    $scope.onSemesterChange = function (semesterID) {
        if (!$scope.data) {
            $scope.data = invoiceSvc.getFinanceSummary();

            $scope.data.$promise.then(function (data) {
                $timeout(function () {

                    var newData = [
                        [$translate.instant('TXT_LBL_SEMESTER'), $translate.instant('TXT_LBL_COURSES'), $translate.instant('TXT_LBL_ACTIONS'), $translate.instant('TXT_VAL_ONEOFF'), $translate.instant('TXT_LBL_PAYMENTS')]
                    ];

                    for (var i = 0; i < data.length; i++) {
                        var d = data[i];

                        newData.push([
                            d['semesterName'],
                            d['courseRegistrationsInvoiced'],
                            d['actionsInvoiced'],
                            d['oneOffsAmount'],
                            d['cashPayments'] + d['bankTransferPayments'] + d['creditCardPayments'] + d['benefitPlusPayments'] + d['onlinePayments']
                        ]);
                    }


                    $scope.chart.data.length = 0;
                    $scope.chart.data.push.apply($scope.chart.data, newData);

                    selectSemesterData(data, semesterID);
                });
            });
        } else {
            selectSemesterData($scope.data, semesterID);
        }
    }
}]);